export const state = {
  userInfo: {}, // 用户信息
  token: '', // 登录 token
  tabsList: [], // 底部tab页签列表
  TabsLeaveSite: [
    { router: '/home', site: 0 },
    { router: '/story', site: 0 },
    { router: '/course', site: 0 },
    { router: '/news', site: 0 },
    { router: '/building', site: 0 },
  ] // 底部table首页路由最后离开时滚动位置
}
